import React, { ComponentProps, useState } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { AddFormElements } from '../../_lib/Form2';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { AdditionalPrivilegeConfigDefaultView } from './views/AdditionalPrivilegeConfigDefaultView';
import { AdditionalPrivilegeCreateEditModal } from './partials/AdditionalPrivilegeCreateEditModal';
import { ContentHeadline } from '../../_lib/components/ContentHeadline';
import { useAppContext } from '../../contexts/AppContext/AppContext';

function AdditionalPrivilegeConfig(props: any) {
  const { t } = useSonTranslation('PrivilegeConfig');
  const { active } = useAppContext().editModeInfo;
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="privilege-config privilege-config__block--no-border">
      <div className="privilege-config__headline privilege-config__headline--border-top">
        <ContentHeadline title={t('additionalPrivileges')} hierarchy={2} modifier="top-headline" />
      </div>
      {active
        ? <div className="privilege-config__add-form-button">
            <AddFormElements name={t('addAdditionalPrivilege')} onClick={() => setShowModal(true)} />
          </div>
        : null}
      <AdditionalPrivilegeConfigDefaultView {...active ? props.views.edit : props.views.default} />
      {showModal && (
        <AdditionalPrivilegeCreateEditModal
          form={props.views.edit.embedded.createForm}
          closeModal={() => setShowModal(false)}
        />
      )}
    </div>
  );
}

export const AdditionalPrivilegeConfigBlock = asFetchableBlock(
  AdditionalPrivilegeConfig,
  BlockType.additionalprivilegeconfig,
  BlockType.additionalprivilegeconfig, // we register this block so it can be refreshed via the useInvalidate hook
);
export type AdditionalPrivilegeConfigBlock = ComponentProps<typeof AdditionalPrivilegeConfigBlock>;
